import { shallowMount } from "@vue/test-utils";
import CustomSelect from "@/components/core/custom/CustomSelect";

describe("CustomSelect component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(CustomSelect);
  });

  it("Renders del component CustomSelect", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
